import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)


import ar from "./locales/ar.json";
import en from "./locales/en.json";
import ch from "./locales/ch.json";
const messages = {
  en: en,
  ch: ch,
  ar: ar
}
const lang = localStorage.getItem('dmlang')

export const i18n = new VueI18n({
    locale: lang ?? 'en',
    messages,
});

